(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["awashi-cart-item-notes"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('awashi-cart-item-notes')) {
    customElements.define('awashi-cart-item-notes', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.querySelector('[data-save-notes]')?.addEventListener('click', () => this.save());
      }

      async save() {
        const button = this.querySelector('[data-save-notes]');
        const status = this.querySelector('[data-notes-status]');
        const properties = {};
        this.querySelectorAll('[data-existing-property]').forEach((input) => {
          properties[input.dataset.propertyKey] = input.value;
        });

        let hasTailoringDetails = false;
        this.querySelectorAll('[data-property-name]').forEach((input) => {
          const key = input.dataset.propertyName;
          const value = input.value.trim();
          if (value) {
            properties[key] = value;
            hasTailoringDetails = true;
          } else {
            delete properties[key];
          }
        });
        properties['طريقة التنفيذ'] = hasTailoringDetails ? 'مقاسات أو ملاحظات خاصة' : 'حسب المقاس المختار';

        button.disabled = true;
        status.textContent = this.dataset.savingText;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: this.dataset.lineKey,
              quantity: Number(this.dataset.quantity),
              properties
            })
          });
          if (!response.ok) throw new Error('Cart update failed');
          status.textContent = this.dataset.savedText;
          window.location.reload();
        } catch (_error) {
          button.disabled = false;
          status.textContent = this.dataset.errorText;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
